import Base from '../../../src/js/classes/Base'
import gsap from 'gsap'

export default class HomeImage extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				wrapper: document.querySelector('[data-transition="wrapper"]'),
				landing: '.s-HomeImage__landing',
				itemsContainer: '.s-HomeImage__landing__images',
				items: '.s-HomeImage__landing__images__image',
				landscape: '.s-HomeImage__landing__landscape',
			},
			settings: {
				enableLandscapeMode: 0,
			},
			classes: {
				initialised: 'initialised',
				preloaded: 'preloaded',
				themeLight: 'theme-light',
			},
		})
	}

	init() {
		const params = new URLSearchParams(window.location.search)
		if (params.get('logout') || params.get('successful_login') || params.get('action') == 'rp') {
			document.body.classList.add(this.classes.preloaded)
			// gsap.set(this.elements.landing, {
			// 	opacity: 0,
			// 	pointerEvents: 'none',
			// })
			window.emitter.emit('pageReady')
		}

		this.setupTheme()

		this.elements.items = gsap.utils.toArray(this.elements.items)

		this.state = {
			speed: 1,
			direction: 'positive',
			touchDeltaY: 0,
			touchY: 0,
			isTouched: false,
			isWindowActive: true,
			extraSpeed: 0,
			isPaused: false,
		}

		this.isMobile = () => window.innerWidth <= 768

		this.parameters = {
			speedFactor: 1.5,
			clampSpeed: 70,
			scrollFactor: this.isMobile() ? window.innerWidth / 50 : window.innerWidth / 600,
			touchSpeedFactor: 0.1,
			baseSpeed: 1,
			lerpDuration: 2,
		}
			
		this.resize()
	}

	setupTheme() {
		if (this.settings.enableLandscapeMode === 1) {
			const theme = this.elements.landscape?.dataset?.theme || 'dark'
			document.body.classList.add(`theme-${theme}`)
		}
	}

	setupItem(item) {
		const boxHeight = item.clientHeight
		item.wrap = gsap.utils.wrap(-boxHeight, window.innerHeight)
	}

	resize() {
		if (this.settings.enableLandscapeMode === 1) {
			this.element.classList.add(this.classes.initialised)
			return
		}
		this.parameters.scrollFactor = this.isMobile() ? window.innerWidth / 50 : window.innerWidth / 600
		this.innerItemsHeight = this.elements.itemsContainer.clientHeight
		this.elements.items.forEach((item) => {
			this.setupItem(item)
		})

		// Mark the element as initialized
		this.element.classList.add(this.classes.initialised)
	}
	
	update(dt) {
		if (this.state.isPaused || this.settings.enableLandscapeMode === 1) return

		// Normalize for consistent speed across all refresh rates
		const ratio = dt ?? 1 // If dt is provided, use it; otherwise assume 60fps
		const refreshRateMultiplier = gsap.ticker.deltaRatio(60) // This gets smaller at higher Hz
		const normalizedRatio = ratio / refreshRateMultiplier // This compensates for high refresh rates
		
		const dir = this.state.direction === 'negative' ? 1 : -1

		gsap.set(this.elements.items, {
			top: (i, target) => {
				const scale = Number(target.dataset.scale) || 1
				const pxPerFrameAt60 = this.parameters.baseSpeed * 2 * scale + (this.state.extraSpeed || 0)
				const step = pxPerFrameAt60 * normalizedRatio * dir
				return (step >= 0 ? '+=' : '-=') + Math.abs(step)
			},
			modifiers: {
				top: (value, target) => {
					const wrap = this.elements.items.find((el) => el === target)?.wrap
					if (!wrap) return value
					return gsap.utils.unitize((n) => wrap(n))(value)
				},
			},
		})
	}

	once() {
		this.init()
		gsap.set(this.element, {
			y: 0,
		})
	}

	leave(resolve) {
		gsap.to(this.elements.wrapper, {
			opacity: 0,
			duration: 0.5,
			ease: 'power2.in',
			onComplete: () => resolve(),
		})
	}

	after() {
		window.scrollTo(0, 0)
		gsap.set(this.elements.wrapper, {
			opacity: 0,
		})
		gsap.to(this.elements.wrapper, {
			opacity: 1,
			duration: 0.5,
			ease: 'power2.out',
			onComplete: () => {
				window.emitter.emit('pageReady')
			},
		})
	}

	unmount() {}
}
